<div class="tw-flex tw-flex-col tw-py-2" cdkDropList [cdkDropListDisabled]="disabled || !config.reorderable" (cdkDropListDropped)="drop($event)">
    @for (item of items; let index = $index, last = $last; track index) {
        <div cdkDrag cdkDragLockAxis="y" cdkDragPreviewContainer="parent" [cdkDragDisabled]="disabled || !config.reorderable">
        <div class="tw-flex tw-items-start tw-gap-4 tw-flex-wrap tw-py-3" data-row (focusout)="touchRowIfLeft($event, index)">
            @if (config.reorderable) {
                <!-- Drag to move the item; with the keyboard, the arrows up and down move it -->
                <span cdkDragHandle data-handle role="button" [attr.tabindex]="disabled ? -1 : 0"
                    class="tw-flex tw-items-center tw-h-14 tw-cursor-grab tw-text-[var(--sys-secondary-text)] tw-touch-none"
                    [attr.aria-label]="'SETTINGS.HUB.REORDER_ITEM' | translate"
                    (keydown.arrowup)="onHandleKey($event, index, -1)"
                    (keydown.arrowdown)="onHandleKey($event, index, 1)">
                    <mat-icon>drag_indicator</mat-icon>
                </span>
            }
            @if (config.caption?.(item); as caption) {
                <div class="tw-flex tw-items-center tw-h-14 tw-w-36 tw-shrink-0">
                    <span class="tw-text-sm tw-text-[var(--sys-secondary-text)] tw-line-clamp-2 tw-break-words" [attr.title]="caption | translate">{{ caption | translate }}</span>
                </div>
            }
            @for (field of config.fields; track field.key) {
                @if (field.control === 'toggle') {
                    <div class="tw-flex tw-items-center tw-h-14 tw-w-32 tw-shrink-0">
                        <mat-slide-toggle
                            [checked]="item[field.key] === true"
                            [disabled]="disabled"
                            (change)="setField(index, field.key, $event.checked)">
                            {{ field.label | translate }}
                        </mat-slide-toggle>
                    </div>
                } @else {
                    <mat-form-field appearance="outline" [subscriptSizing]="rowHasError(index, item) ? 'fixed' : 'dynamic'" class="tw-min-w-[8rem]" [style.flex]="(field.grow ?? 1) + ' 1 0%'" (focusout)="touchField(index, field)">
                        <mat-label>{{ field.label | translate }}</mat-label>
                        @if (field.control === 'select') {
                            <mat-select panelClass="settings-select-panel"
                                [ngModel]="item[field.key]"
                                [disabled]="disabled"
                                (ngModelChange)="setField(index, field.key, $event)">
                                @for (option of optionsByField[field.key]; track option.value) {
                                    <mat-option [value]="option.value">{{ option.translate ? (option.label | translate: option.labelParams) : option.label }}</mat-option>
                                }
                            </mat-select>
                        } @else if (field.control === 'number') {
                            <input matInput type="number"
                                [ngModel]="item[field.key]"
                                [disabled]="disabled"
                                (ngModelChange)="setField(index, field.key, $event)" />
                            @if (field.lookup; as lookupId) {
                                <button matSuffix mat-icon-button type="button" [disabled]="disabled" (click)="pickNumber(index, field.key, lookupId)">
                                    <mat-icon>fact_check</mat-icon>
                                </button>
                            }
                        } @else {
                            <input matInput type="text"
                                [ngModel]="item[field.key]"
                                [disabled]="disabled"
                                (ngModelChange)="setField(index, field.key, $event)" />
                        }
                        @if (shownError(index, item, field); as error) {
                            <mat-hint class="tw-text-red-600">{{ (error === 'required' ? 'NG_MESSAGES.REQUIRED_FIELD' : 'NG_MESSAGES.INVALID_VALUE') | translate }}</mat-hint>
                        }
                    </mat-form-field>
                }
            }
            <div class="tw-flex tw-items-center tw-h-14">
                <button mat-icon-button type="button" color="warn" [attr.aria-label]="'SETTINGS.SETTINGS.DELETE' | translate" [disabled]="disabled" (click)="remove(index)">
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
        </div>
        @if (!last) {
            <mat-divider />
        }
        </div>
    }
    <div class="tw-flex tw-justify-end tw-pt-6">
        <app-action-btn variant="stroked" [disabled]="disabled" (click)="add()">
            <mat-icon>add</mat-icon>
            {{ config.addLabel | translate }}
        </app-action-btn>
    </div>
</div>
